import { BlogType, BlogCountry } from '../models/blog';
import { GhostTag } from '../models/ghost';

type MenuItem = { label: string; path: string };

export type PostCategory = {
  name: string;
  slug: string;
};

type SiteConfig = {
  title: string;
  description: string;
  url: string;
  menuItems: MenuItem[];
  defaultCategory: string;
  categories: PostCategory[];
  tags: GhostTag[];
  countries: BlogCountry[];
  postsPerResult: number;
  analytics: {
    trackingId: string;
  };
};

export const SITE_CONFIG: Record<string, SiteConfig> = {
  blog: {
    title: 'Blog',
    description: 'Everything you need to know about the Future of Work',
    url: 'https://www.kalibrr.com/blog',
    menuItems: [
      { label: 'Start Hiring', path: 'https://www.kalibrr.com/employers' },
      { label: 'Advice', path: 'https://www.kalibrr.com/advice' },
    ],
    defaultCategory: 'blog-b2b',
    categories: [
      { name: 'B2B', slug: 'blog-b2b' },
      { name: 'News', slug: 'blog-news' },
      { name: 'Product Releases', slug: 'blog-product-releases' },
      { name: 'Support', slug: 'blog-support' },
    ],
    tags: [
      { name: 'recruitment', slug: 'content-tags-recruitment' },
      { name: 'human resources', slug: 'content-tags-human-resources' },
      { name: 'hiring', slug: 'content-tags-hiring' },
      { name: 'job tips', slug: 'content-tags-job-tips' },
      { name: 'job interview', slug: 'content-tags-job-interview' },
      { name: 'management', slug: 'content-tags-management' },
      { name: 'event', slug: 'content-tags-event' },
      { name: 'employee engagement', slug: 'content-tags-employee-engagement' },
      { name: 'leadership', slug: 'content-tags-leadership' },
      { name: 'employer-branding', slug: 'content-tags-employer-branding' },
    ],
    countries: [
      { country: "Indonesia", code: "id", slug: "content-id" },
    ],
    postsPerResult: 4,
    analytics: {
      trackingId: 'UA-47900795-2',
    },
  },
  advice: {
    title: 'Advice',
    description: 'Professional career advice for professionals',
    url: 'https://www.kalibrr.com/advice',
    menuItems: [
      { label: 'Get Hired', path: 'httpx://www.kalibrr.com' },
      { label: 'Blog', path: 'https://www.kalibrr.com/blog' },
    ],
    defaultCategory: 'advice-career-advice',
    categories: [
      { name: 'About Kalibrr', slug: 'advice-all-about-kalibrr' },
      { name: 'Career Advice', slug: 'advice-career-advice' },
      { name: 'Fun Stuff', slug: 'advice-fun-stuff' },
      { name: 'Inspiration', slug: 'advice-inspiration' },
      { name: 'Jobs Digests', slug: 'advice-jobs-digests' },
      { name: 'Universities', slug: 'advice-universities' },
    ],
    tags: [
      { name: 'human resources', slug: 'content-tags-human-resources' },
      { name: 'motivation', slug: 'content-tags-motivation' },
      { name: 'jobs', slug: 'content-tags-jobs' },
      { name: 'job tips', slug: 'content-tags-job-tips' },
      { name: 'work-life balance', slug: 'content-tags-work-life-balance-0' },
      { name: 'fresh graduate', slug: 'content-tags-fresh-graduate-0' },
      { name: 'leadership', slug: 'content-tags-leadership' },
      { name: 'job interview', slug: 'content-tags-job-interview' },
      { name: 'professionalism', slug: 'content-tags-professionalism-0' },
      { name: 'resume', slug: 'content-tags-resume-0' },
    ],
    countries: [
      { country: "Indonesia", code: "id", slug: "content-id" },
    ],
    postsPerResult: 4,
    analytics: {
      trackingId: 'UA-47900795-4',
    },
  },
};

export function getPostCategory(blogType: BlogType, tagSlug: string) {
  const categories = SITE_CONFIG[blogType].categories;
  const category = categories.find(
    category => tagSlug == category.slug || tagSlug.startsWith(category.slug)
  );
  if (category) {
    return category.slug;
  } else {
    return tagSlug;
  }
}
